let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ed8Gs")).then(() => parcelRequire('6qIoF'));